import { render, staticRenderFns } from "./StatusIdMov.vue?vue&type=template&id=ae0a2ec8"
import script from "./StatusIdMov.vue?vue&type=script&lang=js"
export * from "./StatusIdMov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports